import { FC } from 'react';
import styled from 'styled-components';
import Button from './Button';
import Icon from './Icon';
import tw from 'twin.macro';
import { ButtonColor, ButtonSize, IconColor, IconSize, Icons } from '../enums';

const StyledInput = styled.input`
  ${tw`flex-1 py-2 px-8 bg-white/80 border border-slate-300 rounded-full`};

  &:focus {
    ${tw`bg-white outline-primary ring-emerald-500 border-emerald-500`};
  }
`;

const RemoveButton = styled(Button)`
  ${tw`absolute flex items-center right-1`};
`;

const StyledIcon = styled(Icon)`
  ${tw`absolute left-2 rotate-180 scale-x-[-1]`};
`;

const Wrapper = styled.div`
${tw`w-full relative`};
`


interface Props {
  filterValue: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearFilter: () => void;
}

const FilterInput: FC<Props> = ({ filterValue, handleChange, clearFilter }) => {
  return (
    <Wrapper>
      <StyledInput
        type="text"
        className="w-full"
        placeholder="Filter..."
        value={filterValue}
        onChange={handleChange}
      />

      {filterValue && (
        <RemoveButton
          size={ButtonSize.medium}
          color={ButtonColor.grey}
          onClick={clearFilter}>
          <Icon icon={Icons.remove} />
        </RemoveButton>
      )}
      <StyledIcon
        icon={Icons.search}
        color={IconColor.gray}
        size={IconSize.medium}
        className='absolute top-3.5 right-2'
      />
    </Wrapper>
  );
};

export default FilterInput;
